import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Dropdown } from "react-bootstrap";

export default function EcommerceCardComponent({

  variant,
  trend,
  number,
  title,
  icon,
  percent
  
}) {
  
  const { t } = useContext(TranslatorContext);

  return (

    <div className={`mc-ecommerce-card ${variant}`}>
      <i className="mc-ecommerce-card-trend material-icons">{trend}</i>
      <div className="mc-ecommerce-card-head">
        <h4 style={{fontSize:number=="NOT ELIGIBLE. BUY BOP FOR $100"?18:""}} className="mc-ecommerce-card-meta">
          <span>{title}</span>
          {title == "BOP Current Coin Price"
            ? "$"
            : title == "My BOP USD Value"
            ? "$"
            : title == "My Total Earnings"
            ? "$"
            : title == "My Wallet Balance"
            ? "$"
            : ""}{" "}
          {number=="NOT ELIGIBLE. BUY BOP FOR $100"?
          <>
          <span style={{fontSize:number=="NOT ELIGIBLE. BUY BOP FOR $100"?18:"",fontWeight:"bold",color:number=="NOT ELIGIBLE. BUY BOP FOR $100"?"":""}}>{number.slice(0,14)}</span> {"\n"}
          <span style={{fontWeight:"bold",fontSize:18}}>{number.slice(-16)}</span>
          
          </>

        :
        number
        }
        </h4>
      </div>
    </div>
  );
}
